/* eslint-disable import/first */
import React from 'react';

export default function Check(props) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style={{ minWidth: '25px' }}>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.66663 9.76503C1.66663 14.2594 5.39746 17.9026 9.99996 17.9026C14.6025 17.9026 18.3333 14.2594 18.3333 9.76503C18.3333 5.27064 14.6025 1.62744 9.99996 1.62744C5.39746 1.62744 1.66663 5.27064 1.66663 9.76503ZM15.0608 7.26597L9.16913 13.0201L5.63329 9.56728L6.81163 8.41663L9.16913 10.7188L13.8825 6.11532L15.0608 7.26597Z"
        fill="#34C759"
      />
    </svg>
  );
}
